import { render, staticRenderFns } from "./BackOrder.vue?vue&type=template&id=51df96ba"
import script from "./BackOrder.vue?vue&type=script&lang=js"
export * from "./BackOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports